import {create} from 'zustand';
import {UseSelectedProviderStoreProps} from './types';

export const useSelectedProviderStore = create<UseSelectedProviderStoreProps>(set => ({
	provider: null,
	setProvider: provider => set({provider}),
	reset: () => set({provider: null}),
}));
